import React, { useState } from 'react';
import emailjs from 'emailjs-com';


function Contact() {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.send(
      'service_q2kk0pg',        // Replace with your EmailJS service ID
      'template_rj8yup3',       // Replace with your EmailJS template ID
      formData,
      'Otoba8htXPl0-qcwp' // Replace with your EmailJS public key
    )
    .then((response) => {
      alert('Message sent successfully!');
      setFormData({ name: '', email: '', message: '' });
    })
    .catch((err) => {
      console.error('FAILED...', err);
      alert('Failed to send message.');
    });
  };
  return (
    <div id="contact" className="bg-teal-900 text-white py-16 px-6 shadow-lg">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12">

        {/* LEFT SIDE: Info Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Card 1 */}
          <div className="bg-teal-800 p-6 rounded-xl">
            <h3 className="text-xl font-bold text-teal-300 mb-2">Our Office</h3>
            <p className="text-teal-100">
              KK 04 Ave - Gikondo<br />
              Kigali, Rwanda
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-teal-800 p-6 rounded-xl">
            <h3 className="text-xl font-bold text-teal-300 mb-2">Contact Us</h3>
            <p className="text-teal-100">
              Phone: +250 788 570 601<br />
              Email: info@edgesdesigngroup.com
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-teal-800 p-6 rounded-xl">
            <h3 className="text-xl font-bold text-teal-300 mb-2">Opening Hours</h3>
            <p className="text-teal-100">
              Mon - Fri: 8:00 AM – 5:00 PM<br />
              Sat - Sun: Closed
            </p>
          </div>

          {/* Card 4 */}
          <div className="bg-teal-800 p-6 rounded-xl">
            <h3 className="text-xl font-bold text-teal-300 mb-2">Follow Us</h3>
            <div className="flex flex-col gap-2">
              <a href="https://www.facebook.com/profile.php?id=61559936103250" target="_blank" rel="noopener noreferrer" className="text-teal-100 hover:text-white transition">Facebook</a>
              {/* <a href="https://www.pinterest.com/edgesgroup6/" target="_blank" rel="noopener noreferrer" className="text-teal-100 hover:text-white transition">Pinterest</a> */}
              <a href="https://www.instagram.com/edges.design.group/" target="_blank" rel="noopener noreferrer" className="text-teal-100 hover:text-white transition">Instagram</a>
              <a href="https://www.linkedin.com/in/edges-design-group-06857a364/?skipRedirect=true" target="_blank" rel="noopener noreferrer" className="text-teal-100 hover:text-white transition">LinkedIn</a>
              {/* <a href="https://x.com/Edges_Design" target="_blank" rel="noopener noreferrer" className="text-teal-100 hover:text-white transition">X</a> */}
              {/* <a href="https://www.youtube.com/@Edges_Design_Group" target="_blank" rel="noopener noreferrer" className="text-teal-100 hover:text-white transition">Youtube</a> */}
            </div>
          </div>
        </div>

        {/* RIGHT SIDE: Contact Form */}
        <div className="bg-teal-800 p-8 rounded-xl">
          <h2 className="text-2xl font-bold text-white mb-6">Get in Touch</h2>
          <form className="space-y-4" onSubmit={sendEmail}>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Full Name"
              required
              className="w-full px-4 py-3 rounded bg-teal-700 text-white placeholder-teal-200 focus:outline-none focus:ring-2 focus:ring-teal-400"
            />
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Email Address"
              required
              className="w-full px-4 py-3 rounded bg-teal-700 text-white placeholder-teal-200 focus:outline-none focus:ring-2 focus:ring-teal-400"
            />
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              rows="4"
              placeholder="Your Message"
              required
              className="w-full px-4 py-3 rounded bg-teal-700 text-white placeholder-teal-200 focus:outline-none focus:ring-2 focus:ring-teal-400"
            ></textarea>
            <button
              type="submit"
              className="w-full bg-teal-600 hover:bg-teal-500 text-white font-semibold py-3 rounded transition"
            >
              Send Message
            </button>
          </form>
        </div>

      </div>
    </div>
  );
}

export default Contact;
